// Image editor options: https://uppy.io/docs/image-editor/
// Cropper options: https://github.com/fengyuanchen/cropperjs/blob/HEAD/README.md#options

import ImageDimensions from '../ImageDimensions';

const ImageEditorConfig = (props = {}) => {
  const { convertOptions, imageEditorOptions } = props;
  const { width, height, fit, transparency } = convertOptions || {};
  const { showImageDimensions = true } = imageEditorOptions || {};
  const croppedCanvasOptions = {};

  const imageDimensions = new ImageDimensions({
    parentContainerSelector: '.cropper-container'
  });

  if (transparency === false) {
    croppedCanvasOptions.fillColor = 'white';
  }

  const cropperOptions = {
    viewMode: 1,
    background: false,
    autoCropArea: 1,
    responsive: true,
    croppedCanvasOptions,
    ready: (e) => {
      if (showImageDimensions) {
        imageDimensions.appendContainer();
        imageDimensions.render(e?.target?.cropper?.getData());
      }
    },
    crop: (e) => {
      if (showImageDimensions) {
        imageDimensions.render(e?.detail);
      }
    }
  };

  let cropSquare = true,
    cropWidescreen = true,
    cropWidescreenVertical = true;

  if (fit === 'crop' && width && height) {
    cropSquare = width === height;
    cropWidescreen = false;
    cropWidescreenVertical = false;

    cropperOptions.aspectRatio = width / height;
  }

  // Note on quality: This is passed through to https://developer.mozilla.org/en-US/docs/Web/API/HTMLCanvasElement/toBlob
  // A quality of 1 can increase file size
  return {
    cropperOptions,
    actions: {
      revert: true,
      rotate: true,
      granularRotate: true,
      flip: true,
      zoomIn: true,
      zoomOut: true,
      cropSquare,
      cropWidescreen,
      cropWidescreenVertical,
    },
  };
};

export default ImageEditorConfig;
